import { useState, useEffect } from 'react';

export const useGetCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState<string>('');

  useEffect(() => {
    // For now, return empty string - CSRF handling may be implemented later
    setCsrfToken('');
  }, []);

  return csrfToken;
};
